import { FormattedMessage, useIntl } from 'react-intl';
import SigningForm from 'src/models/SigningForm';
import { UseMutationResult } from '@tanstack/react-query';
import { User } from 'src/models/user';
import DateOnlyInput from '../_common/DateOnlyInput/DateOnlyInput';
import RadioButtonRow from './RadioButtonRow';

interface FormFieldsProps {
  form: SigningForm;
  setForm: (form: SigningForm) => void;
  disabled: boolean;
  onChange?: () => void;
}

export default function EndSemesterFormFields({ form, setForm, disabled, onChange }: FormFieldsProps) {
  const { formatMessage } = useIntl();

  function handleChange(fieldName: string, value: boolean | Date | string | null) {
    setForm({ ...form, [fieldName]: value });
    if (onChange) onChange();
  }

  return (
    <>
      <h3 className="border-b-2" style={{ borderColor: 'black' }}>
        <FormattedMessage id="end-semester" />
      </h3>
      <div className="flex items-center mb-4">
        <div style={{ height: 'fit-content' }}>
          <FormattedMessage id="signingFormEndSemesterDateLabel" />:&nbsp;
        </div>
        <div>
          <DateOnlyInput
            disabled={disabled}
            value={form.endSemesterCompletedDate}
            setValue={value => handleChange('endSemesterCompletedDate', value)}
          />
        </div>
      </div>
      <hr className="mt-4 mb-4" />
      <RadioButtonRow
        checked={form.generalCompetenceAreasPassed}
        label={formatMessage({ id: 'signing-form-general-competence-areas-passed' })}
        onChange={checked => handleChange('generalCompetenceAreasPassed', checked)}
        disabled={disabled}
        checkedOptionLabel={formatMessage({ id: 'yes' })}
        uncheckedOptionLabel={formatMessage({ id: 'noText' })}
      />
      <hr className="mt-4 mb-4" />
      <RadioButtonRow
        checked={form.specificCompetenceAreasPassed}
        label={formatMessage({ id: 'signing-form-approved-specific-competencies' })}
        onChange={checked => handleChange('specificCompetenceAreasPassed', checked)}
        disabled={disabled}
        checkedOptionLabel={formatMessage({ id: 'yes' })}
        uncheckedOptionLabel={formatMessage({ id: 'noText' })}
      />
    </>
  );
}
